import React, { useEffect, useState } from "react";
import Card from "../../UI/Card/Card";
import styles from "./Values.module.css";

import { visionText, missionText, valuesText } from "./texts";
import Slider from "../../UI/Slider/Slider";

interface ValuesProps {

}

const Values: React.FC<ValuesProps> = ({ }) => {

    const [isVisible, setVisible] = useState<boolean>(false);

    useEffect(() => {
        const intro_s = document.getElementById("values") as HTMLElement;
        const h = intro_s?.offsetTop as number;

        document.addEventListener('scroll', () => {
            if (!(window.scrollY < (h))) {
                setVisible(true);
            }
        })
    })

    const [isDesktop] = useState<boolean>(!(window.innerWidth < 600))
    return (
        <div className={styles.values} id="values">
            <div className={isVisible ? styles.bottomtopup : styles.none}>
                <div className={styles.card}>

                    {
                        isDesktop ? <>

                            <Card title="VISÃO" side="left" secondary>
                                <p>Ser referência nacional em educação tecnológica e digital, promovendo o acesso ao conhecimento por meio da robótica educacional, pensamento computacional, programação, desenvolvimento de games, impressão 3D e outras linguagens do século 21. Queremos inspirar escolas, educadores e estudantes a transformar o presente e construir o futuro.</p>
                            </Card>
                            <Card title="MISSÃO" side="left" secondary>
                                <p>Transformar a educação por meio de soluções pedagógicas inovadoras que unem teoria e prática. Desenvolvemos materiais, formações e experiências que despertam o protagonismo, o raciocínio lógico, a criatividade e a autonomia de crianças, adolescentes e educadores, sempre com foco em valores humanos e impacto social.</p>
                            </Card>
                            <Card title="VALORES" side="left" secondary>
                                <ul className={styles.valuesList}>
                                    <p>• Educação como ferramenta de transformação social</p>
                                    <p>• Ética, empatia e responsabilidade coletiva</p>
                                    <p>• Inovação com propósito</p>
                                    <p>• Compromisso com a inclusão digital e tecnológica</p>
                                    <p>• Sustentabilidade e respeito ao meio ambiente</p>
                                    <p>• Criatividade, colaboração e pensamento crítico</p>
                                    <p>• Aprender fazendo: o "saber fazer" como base para o "ser"</p>
                                </ul>
                            </Card>
                        </> :
                            <>
                            <Slider elementsPerSlide={1} elementsToMove={1}>
                                <Card title="VISÃO" side="left" secondary>
                                    <p>Ser referência nacional em educação tecnológica e digital, promovendo o acesso ao conhecimento por meio da robótica educacional, pensamento computacional, programação, desenvolvimento de games, impressão 3D e outras linguagens do século 21. Queremos inspirar escolas, educadores e estudantes a transformar o presente e construir o futuro.</p>
                                </Card>
                                <Card title="MISSÃO" side="left" secondary>
                                    <p>Transformar a educação por meio de soluções pedagógicas inovadoras que unem teoria e prática. Desenvolvemos materiais, formações e experiências que despertam o protagonismo, o raciocínio lógico, a criatividade e a autonomia de crianças, adolescentes e educadores, sempre com foco em valores humanos e impacto social.</p>
                                </Card>
                                <Card title="VALORES" side="left" secondary>
                                    <p>- Educação como ferramenta de transformação social</p>
                                    <p>- Ética, empatia e responsabilidade coletiva</p>
                                    <p>- Inovação com propósito</p>
                                    <p>- Compromisso com a inclusão digital e tecnológica</p>
                                    <p>- Sustentabilidade e respeito ao meio ambiente</p>
                                    <p>- Criatividade, colaboração e pensamento crítico</p>
                                    <p>- Aprender fazendo: o "saber fazer" como base para o "ser"</p>
                                </Card>
                            </Slider>
                            </>
                    }

                </div>
            </div>

        </div>
    )
}
                                // <Slider elementsPerSlide={1} elementsToMove={1}>
                                // <Card title="Bem-vindo" side="left" secondary>
                                //     <p>Este é um texto dentro do Card.</p>
                                //     <ul>
                                //         <li>Item 1</li>
                                //         <li>Item 2</li>
                                //     </ul>
                                // </Card>
                                //     {/* <Card title="VISÃO" text={visionText} side="left" />
                                //     <Card title="MISSÃO" text={missionText} secondary />
                                //     <Card title="VALORES" text={valuesText} side="right" /> */}
                                // </Slider>

export default Values;